module.exports = __webpack_public_path__ + "Roboto-Medium.2b4f394ce87ea4e7a68b.svg";


//////////////////
// WEBPACK FOOTER
// /Users/vladislavlazurenko/IdeaProjects/luiziana/frontend/src/roboto-fontface/fonts/roboto/Roboto-Medium.svg
// module id = ../../../../../src/roboto-fontface/fonts/roboto/Roboto-Medium.svg
// module chunks = styles